import React, { Component } from "react";
import PropTypes from "prop-types";
import shop from "../../../api/shop";
import { connect } from "react-redux";
import { userIsAdmin } from "../../../auth";
import { getTranslate } from "react-localize-redux";
import { store } from "../../../main.js";
import { ListGroup, ListGroupItem } from "reactstrap";
import {
  loadingSalesmen,
  storeSalesmen,
  setOZ,
  resetState
} from "../../../store/common";
import { RingLoader } from "react-spinners";

class SalesmenContainer extends Component {
  componentWillMount = () => {
    store.dispatch(resetState());
    store.dispatch(loadingSalesmen(true));
    shop.getSalesmen(salesmenPromise => {
      salesmenPromise.then(salesmen => {
        store.dispatch(storeSalesmen(salesmen));
        store.dispatch(loadingSalesmen(false));
      });
    });
  };

  componentWillReceiveProps = props => {
    localStorage.setItem("token", props.adminToken);
  };

  render() {
    return (
      <div>
        <h1>Salesmen list</h1>
        {!this.props.isSalesmenLoading &&
          this.props.salesmen &&
          this.props.salesmen.length > 0 ? (
            <ListGroup>
              {this.props.salesmen.map(s => (
                <ListGroupItem
                  key={s.id}
                  className="d-flex justify-content-between"
                  onClick={() => this.props.setOZ(s)}
                >
                  <div>
                    {s.first_name} {s.last_name}
                  </div>
                  <div>{s.email}</div>
                </ListGroupItem>
              ))}
            </ListGroup>
          ) : (
            <div className="spinner">
              <RingLoader
                color={"#d42e2b"}
                loading={this.props.isSalesmenLoading}
                size={120}
                margin={20}
              />
            </div>
          )}
      </div>
    );
  }
}

SalesmenContainer.propTypes = {
  translate: PropTypes.func
};

const mapStateToProps = ({ common, locale }) => ({
  translate: getTranslate(locale),
  isSalesmenLoading: common.salesmenLoading,
  salesmen: common.salesmen,
  adminToken: common.adminToken
});

const mapDispatchToProps = dispatch => ({
  setOZ: oz => dispatch(setOZ(oz))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(userIsAdmin(SalesmenContainer));



// WEBPACK FOOTER //
// ./src/routes/Salesmen/containers/SalesmenContainer.js